module.exports = __webpack_public_path__ + "media/images/sp/special_plans/text_spot-ca92c792bbd2411e1bd0608e7891846b.svg";